import { GetStaticProps } from 'next';
import configureSentryScope from '../helpers/configureSentryScope';
import getAboutPageViewModels from '../helpers/getAboutPageViewModels';
import AboutPage from '../components/AboutPage/AboutPage';
import expandMarkdownSnippets from '../helpers/expandMarkdownSnippets';
import { getPlaiceholder } from 'plaiceholder';
import convertImageUrlToS3ImageUrl from '../helpers/convertImageUrlToS3ImageUrl';
import buildComponentViewModelsFromEnhancedMarkdowns from '../helpers/buildComponentViewModelsFromEnhancedMarkdowns';

export const AboutPagePath = '/about';

export default AboutPage;

export const getStaticProps: GetStaticProps = async ({ params }) => {
  configureSentryScope(params);

  const pageViewModels = await getAboutPageViewModels();

  pageViewModels.aboutPage.body = await expandMarkdownSnippets(
    pageViewModels.aboutPage.body
  );

  const componentViewModels =
    await buildComponentViewModelsFromEnhancedMarkdowns(
      [
        pageViewModels.aboutPage.body,
        ...pageViewModels.aboutPage.staffAvatars.map(
          (avatar) =>
            `<Image src="${avatar.imageUrl}" width="120" height="120">`
        ),
      ],
      {
        getPlaiceholder: async (src: string) =>
          await getPlaiceholder(convertImageUrlToS3ImageUrl(src)),
      }
    );

  return {
    props: {
      googleAnalytics: pageViewModels.googleAnalytics,
      header: pageViewModels.header,
      footer: pageViewModels.footer,
      page: pageViewModels.aboutPage,
      viewModels: componentViewModels,
    },
    revalidate: 600,
  };
};
